import { MongoBase } from "./MongoBase";
export class LocationBase extends MongoBase {
    LocationId:string = '';
    LocationName:string = '';
}
